import { render } from "./GiftCard.vue?vue&type=template&id=7cc934fb&scoped=true"
import script from "./GiftCard.vue?vue&type=script&lang=js"
export * from "./GiftCard.vue?vue&type=script&lang=js"

import "./GiftCard.vue?vue&type=style&index=0&id=7cc934fb&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cc934fb"]])

export default __exports__